<template>
    <div>
        <v-dialog v-model="dialog_reorder" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">
            <v-card>

                <v-toolbar flat>
				    <v-toolbar-side-icon @click="closeDialogWeb"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">Re-Order Footer Section</v-toolbar-title>

				    <v-spacer></v-spacer>
				</v-toolbar>

                <v-card-text nopadding>

                    <div class="pa-2 mt-3" @click="fn_setFooterStyle(1)">
                        <div style="float: left;" class="mr-2"><v-icon color="primary">{{$parent.footerSection == 1 ? 'radio_button_checked' : 'radio_button_unchecked'}}</v-icon></div>
                        <v-layout row wrap style="border:0.5px solid">
                            <v-flex xs9 sm9 md9 style="border-right:0.5px solid">
                                <div class="pa-1" style="border-bottom:0.5px solid">Terms</div>
                                <div class="pa-1" style="border-bottom:0.5px solid">Print Note</div>
                                <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                        <div class="pa-1">UPI Details</div>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                        <div class="pa-1">Bank Details</div>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs3 sm3 md3>
                                <div class="pa-1">Signatory</div>
                            </v-flex>
                        </v-layout>
                    </div>

                    <div class="pa-2 mt-3" @click="fn_setFooterStyle(2)">
                        <div style="float: left;" class="mr-2"><v-icon color="primary">{{$parent.footerSection == 2 ? 'radio_button_checked' : 'radio_button_unchecked'}}</v-icon></div>
                        <v-layout row wrap style="border:0.5px solid">
                            <v-flex xs9 sm9 md9 style="border-right:0.5px solid">
                                <div class="pa-1" style="border-bottom:0.5px solid">Print Note</div>
                                <v-layout row wrap style="border-bottom:0.5px solid">
                                    <v-flex xs6 sm6 md6>
                                        <div class="pa-1">UPI Details</div>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                        <div class="pa-1">Bank Details</div>
                                    </v-flex>
                                </v-layout>
                                <div class="pa-1">Terms</div>
                            </v-flex>
                            <v-flex xs3 sm3 md3>
                                <div class="pa-1">Signatory</div>
                            </v-flex>
                        </v-layout>
                    </div>

                    <div class="pa-2 mt-3" @click="fn_setFooterStyle(3)">
                        <div style="float: left;" class="mr-2"><v-icon color="primary">{{$parent.footerSection == 3 ? 'radio_button_checked' : 'radio_button_unchecked'}}</v-icon></div>
                        <v-layout row wrap style="border:0.5px solid">
                            <v-flex xs9 sm9 md9 style="border-right:0.5px solid">
                                <v-layout row wrap style="border-bottom:0.5px solid">
                                    <v-flex xs6 sm6 md6>
                                        <div class="pa-1">UPI Details</div>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                        <div class="pa-1">Bank Details</div>
                                    </v-flex>
                                </v-layout>
                                <div class="pa-1" style="border-bottom:0.5px solid">Print Note</div>
                                <div class="pa-1">Terms</div>
                            </v-flex>
                            <v-flex xs3 sm3 md3>
                                <div class="pa-1">Signatory</div>
                            </v-flex>
                        </v-layout>
                    </div>

                    <!-- <div class="pa-2">
                        <div style="float: left;" class="mr-2"><v-icon color="primary">radio_button_unchecked</v-icon></div>
                        <v-layout row wrap style="border:0.5px solid">
                            <v-flex xs9 sm9 md9 style="border-right:0.5px solid">
                                <v-layout row wrap>
                                    <v-flex xs6 sm6 md6>
                                        <div class="pa-1">UPI Details</div>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                        <div class="pa-1">Bank Details</div>
                                    </v-flex>
                                </v-layout>
                                <div class="pa-1">Terms</div>
                                <div class="pa-1">Print Note</div>
                            </v-flex>
                            <v-flex xs3 sm3 md3 right-align>
                                <div class="pa-1">Signatory</div>
                            </v-flex>
                        </v-layout>
                    </div> -->
                </v-card-text>
            </v-card>   
        </v-dialog>
    </div>
</template>     

<script>

export default{
    data(){ 
        return{
            dialog_reorder:false,
            // footerStyle:1
        }
    },
    methods:{
        openDialogWeb: function (style) {
            this.dialog_reorder = true;
            // this.footerStyle = style;
        },

        closeDialogWeb: function () {
            this.dialog_reorder = false;
        },

        fn_setFooterStyle: function(style){
            this.$parent.footerSection = style;
            this.closeDialogWeb();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/invoice_templates/dialogs/dialog_reorder.vue